/**
 * @description Core CheckoutButtons implementation
 * @param CheckoutButtons Base widget for extending
 * @returns Checkout Buttons (PayPal, ApplePay, etc.) class
 */
function CoreCheckoutButtonsClassCreator(CheckoutButtons: import('widgets/cart/CheckoutButtons').TCheckoutButtons) {
    /**
     * @category widgets
     * @subcategory cart
     * @class CoreCheckoutButtons
     * @augments CheckoutButtons
     * @classdesc Represents CheckoutButtons component for making emit after initialization
     */
    class CoreCheckoutButtons extends CheckoutButtons {
        /**
         * @description Scrolls cart error messages into viewport
         */
        scrollToError() {
            this.emitWithoutContext('scrolltoerror');
        }
    }

    return CoreCheckoutButtons;
}

export type TCoreCheckoutButtons = ReturnType<typeof CoreCheckoutButtonsClassCreator>;

export type TCoreCheckoutButtonsInstance = InstanceType<TCoreCheckoutButtons>;

export default CoreCheckoutButtonsClassCreator;
